(function () {
  'use strict';

  var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  if (['fr', 'es', 'it'].indexOf(locale) === -1) return;

  var marker = 'co-installation-unavailable';
  var primaryNames = ['Montage en Installatie', 'Kies een installatie partner', 'Kies een installatie partner-unlock'];
  var primaryClasses = /(?:^|\s)(?:options-mk-2--installation|location_selector|location_selector1)(?:\s|$)/;
  var chargeAttributes = ['gpo-data-variant-id', 'gpo-data-product-handle', 'data-addon-price', 'data-quantity', 'data-value'];
  var running = false;

  function removeAttributes(node, names) {
    names.forEach(function (name) { if (node.hasAttribute(name)) node.removeAttribute(name); });
  }

  function serviceDefinitions(app) {
    var configs = window.GPOConfigs || {};
    var id = app.getAttribute('data-option-set-id');
    var option = configs.option && String(configs.option.id) === id ? configs.option : (configs.options || {})[id];
    var elements = [];
    function collect(items) {
      (items || []).forEach(function (element) {
        elements.push(element);
        if (element.elements) collect(element.elements);
      });
    }
    collect(option && option.elements);
    var ids = new Set();
    elements.forEach(function (element) {
      if (primaryNames.indexOf(element.label_on_cart) !== -1 || primaryClasses.test(element.class_name || '')) ids.add(element.id);
    });
    // Only the enabled-installation branch is a service. The disabled branch
    // includes the camera that customers install themselves.
    elements.forEach(function (element) {
      if (element.conditionalField && element.clo && (element.clo.whens || []).some(function (condition) {
        return condition.where === 'ENABLED' && ids.has(condition.select);
      })) ids.add(element.id);
    });
    return elements.filter(function (element) { return ids.has(element.id); });
  }

  function neutralize(control) {
    var changed = !control.disabled || control.checked || control.hasAttribute('presence') || control.hasAttribute('required');
    if (control.type === 'checkbox' || control.type === 'radio') {
      control.checked = false;
    } else {
      changed = changed || control.value !== '';
      control.value = '';
    }
    if (!control.disabled) control.disabled = true;
    if (!control.hasAttribute('data-unavailable')) control.setAttribute('data-unavailable', '');
    removeAttributes(control, ['required', 'presence', 'checked', 'data-default-value'].concat(chargeAttributes));
    control.querySelectorAll('option').forEach(function (option) {
      option.selected = false;
      removeAttributes(option, ['selected'].concat(chargeAttributes));
      if (!option.disabled) option.disabled = true;
    });
    if (control.tagName === 'SELECT') control.selectedIndex = -1;
    return changed;
  }

  function reconcile(forceChange) {
    if (running) return;
    running = true;
    try {
      var fields = new Set(primaryNames);
      var controls = [];
      document.querySelectorAll('.gpo-app').forEach(function (app) {
        var definitions = serviceDefinitions(app);
        var ids = new Set(definitions.map(function (element) { return element.id; }));
        definitions.forEach(function (element) { if (element.label_on_cart) fields.add(element.label_on_cart); });
        app.querySelectorAll('.gpo-element').forEach(function (row) {
          var primary = Array.from(row.querySelectorAll('[data-field-name]')).some(function (control) {
            return primaryNames.indexOf(control.getAttribute('data-field-name')) !== -1;
          });
          if (!primary && !ids.has(row.getAttribute('data-element-id')) && !primaryClasses.test(row.className) && !row.classList.contains('cod-payment') && !row.classList.contains(marker)) return;
          if (!row.classList.contains(marker)) row.classList.add(marker);
          row.querySelectorAll('input, select, textarea, button').forEach(function (control) {
            var field = control.getAttribute('data-field-name');
            if (field) fields.add(field);
            if (neutralize(control) || forceChange) controls.push(control);
          });
        });
      });
      // Globo copies choices into a separate hidden form. Clear those copies
      // too: these attributes are what its add-to-cart serializer charges.
      document.querySelectorAll('.gpo-hidden-inputs [data-field-name]').forEach(function (input) {
        if (!fields.has(input.getAttribute('data-field-name'))) return;
        input.value = '';
        if (!input.disabled) input.disabled = true;
        removeAttributes(input, ['name', 'value'].concat(chargeAttributes));
      });
      controls.forEach(function (control) {
        control.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } finally {
      running = false;
    }
  }

  // Capture resets restored selections before Globo's target listeners can
  // serialize them. Its own change handlers update totals and bundle metadata.
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.gpo-app, .gpo-hidden-inputs')) reconcile(false);
  }, true);
  document.addEventListener('gpoRenderCompleted', function () { reconcile(true); });
  document.addEventListener('DOMContentLoaded', function () { reconcile(true); });
  new MutationObserver(function (records) {
    var relevant = records.some(function (record) {
      if (record.target.closest && record.target.closest('.gpo-app, .gpo-hidden-inputs')) return true;
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('.gpo-app, .gpo-hidden-inputs') || node.querySelector('.gpo-app, .gpo-hidden-inputs'));
      });
    });
    if (relevant) reconcile(false);
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['disabled', 'checked', 'selected', 'name', 'data-default-value', 'data-field-name', 'gpo-data-variant-id', 'gpo-data-product-handle', 'data-addon-price']
  });
  reconcile(true);
}());
